var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCareer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "white",
    fillOpacity: 0.39
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 46,
    height: 46,
    rx: 23,
    stroke: "white",
    strokeOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3027 26.1999C15.3933 27.775 14.9387 28.5634 15.0066 29.2097C15.0659 29.7734 15.3617 30.2851 15.8203 30.6182C16.3459 31.0001 17.2547 31.0001 19.0724 31.0001H28.7753C30.5929 31.0001 31.5017 31.0001 32.0272 30.6182C32.4858 30.2851 32.7818 29.7734 32.841 29.2097C32.9089 28.5634 32.4545 27.775 31.5451 26.1999L26.6953 17.7999C25.7859 16.2247 25.331 15.4372 24.7373 15.1729C24.2195 14.9424 23.6278 14.9424 23.11 15.1729C22.5166 15.4371 22.062 16.2246 21.1533 17.7984L16.3027 26.1999Z",
    stroke: "#1F6FA0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareer);
export default __webpack_public_path__ + "static/media/career.51bf37f5433e5fad2dd14153f38cca78.svg";
export { ForwardRef as ReactComponent };